import { Option } from "funfix-core"

export const useGAClientId = (
  gaCidRawCookieValue?: string
): Option<{ "ga-client-id": string }> => {
  return Option.of(gaCidRawCookieValue).flatMap(gaCidCookieValue => {
    if (!gaCidCookieValue.startsWith("GA1.")) {
      return Option.none()
    }

    return Option.of(gaCidCookieValue.split("GA1.").pop()).flatMap(it => {
      return (
        it.substring(2) === "" ? Option.none() : Option.some(it.substring(2))
      ).map(gaClientId => ({
        "ga-client-id": gaClientId
      }))
    })
  })
}

export function getDocumentReferrer(
  referrer?: string
): Option<{ "ga-referrer": string }> {
  if (referrer && referrer !== "") {
    return Option.some({ "ga-referrer": referrer })
  } else {
    return Option.none()
  }
}

interface DataLayerEvent {
  originalLocation?: string
}

export function originalLocation(
  windowDataLayer?: DataLayerEvent[]
): Option<{ "ga-original-location": string }> {
  if (!windowDataLayer) {
    return Option.none()
  }

  return Option.of(
    windowDataLayer.find(
      dataLayerObject => dataLayerObject.originalLocation !== undefined
    )
  ).map(it => ({
    "ga-original-location": it.originalLocation!
  }))
}

export function gclidForPaidAttribution(): Option<{
  "google-ads-id": string | null
}> {
  const gclid = sessionStorage.getItem("gclid")
  if (gclid) {
    return Option.of({
      "google-ads-id": sessionStorage.getItem("gclid")
    })
  } else {
    return Option.none()
  }
}

export function combineGAValuesIntoCustomData(
  gaCidRawCookieValue?: string,
  referrer?: string,
  windowDataLayer?: DataLayerEvent[]
): Option<Record<string, unknown>> {
  const gaValues = [
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useGAClientId(gaCidRawCookieValue),
    getDocumentReferrer(referrer),
    originalLocation(windowDataLayer),
    gclidForPaidAttribution()
  ]
    .filter(it => it.nonEmpty())
    .map(it => it.value)

  if (gaValues.length === 0) {
    return Option.none()
  } else {
    const gaValueObject = gaValues.reduce(
      (gaValueAccumulator, gaValue) => ({
        ...gaValueAccumulator,
        ...gaValue
      }),
      {}
    )
    return Option.some(gaValueObject)
  }
}
